import React, { } from "react";
import { useEsfContext } from "../_EsfWalkThrough/EsfContext";import { useTranslation } from "react-i18next";
import { colors, fonts, frames, glyphs } from "../../../Styles";

interface ActiveStationsListProps {
  focus_view?: boolean;
}

export default function ActiveStationsList({ focus_view }: ActiveStationsListProps) {
  const { t } = useTranslation();
  const { state: { selectedStations, locationResults } } = useEsfContext();
  
  if (!selectedStations || selectedStations?.length === 0) return;

  console.log(locationResults)

  return (
    selectedStations.map((station) => {
      return (
        <div key={"station_" + station.station_id} style={{ display: "grid", gridTemplateColumns: "80px 15px 1fr 1fr", gridTemplateRows: "1fr", gap: "10px", /*opacity: dimmed ? "0.5" : "1"*/}}>
          <p key={'name_' + station.station_id} style={{ gridArea: "1/1/2/2", height: "20px", ...fonts.paragraph, ...(focus_view ? fonts.fontSize3 : fonts.fontSize4), color: colors.greyDarkPrimary }}>
            {`${t("esfWalkThroughPages.esfWalkThrough.station", { defaultValue: "Station" })} ${selectedStations.find(loc => loc.station_id === station.station_id)?.name}`}
          </p>
          {locationResults !== undefined && locationResults[station.station_id] !== undefined &&
            <div key={'res_' + station.station_id} style={{ gridArea: "1/2/2/3", height: "15px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {locationResults[station.station_id]
                ? <glyphs.Check fillColor={colors.systemGreen} size={"20px"} /> 
                : <glyphs.Empty fillColor={colors.systemRed} size={"20px"} />
              }
            </div>
          }
        </div>
      )
    })
  )
}